<p>{{ 'dashboard.ui.dashboardWorks' | transloco }}</p>
